import rem from '../tools/rem'

export default `
    max-width: ${rem('1280px')};
    margin: 0 auto;
`
